export const CHANGE_SPORT_SECTION_VISIBILITY =
  'CALENDAR/CHANGE_SPORT_SECTION_VISIBILITY';
export const CHANGE_ATG_SECTION_VISIBILITY =
  'CALENDAR/CHANGE_ATG_SECTION_VISIBILITY';
export const CHANGE_ATG_LIST_VISIBILITY = 'CALENDAR/CHANGE_ATG_LIST_VISIBILITY';
export const CHANGE_SPORT_LIST_VISIBILITY =
  'CALENDAR/CHANGE_SPORT_LIST_VISIBILITY';

export const REQUEST_ATG_CALENDAR = 'CALENDAR/REQUEST_ATG_CALENDAR';
export const RECEIVE_ATG_CALENDAR = 'CALENDAR/RECEIVE_ATG_CALENDAR';
export const RECEIVE_ATG_CALENDAR_ERROR = 'CALENDAR/RECEIVE_ATG_CALENDAR_ERROR';

export const REQUEST_ATG_JACKPOTS = 'CALENDAR/REQUEST_ATG_JACKPOTS';
export const RECEIVE_ATG_JACKPOTS = 'CALENDAR/RECEIVE_ATG_JACKPOTS';
export const RECEIVE_ATG_JACKPOTS_ERROR = 'CALENDAR/RECEIVE_ATG_JACKPOTS_ERROR';

export const REQUEST_SPORT_CALENDAR = 'CALENDAR/REQUEST_SPORT_CALENDAR';
export const RECEIVE_SPORT_CALENDAR = 'CALENDAR/RECEIVE_SPORT_CALENDAR';
export const RECEIVE_SPORT_CALENDAR_ERROR =
  'CALENDAR/RECEIVE_SPORT_CALENDAR_ERROR';

export const REQUEST_SPORT_JACKPOTS = 'CALENDAR/REQUEST_SPORT_JACKPOTS';
export const RECEIVE_SPORT_JACKPOTS = 'CALENDAR/RECEIVE_SPORT_JACKPOTS';
export const RECEIVE_SPORT_JACKPOTS_ERROR =
  'CALENDAR/RECEIVE_SPORT_JACKPOTS_ERROR';

export const REQUEST_BET_TIPS = 'CALENDAR/REQUEST_BET_TIPS';
export const RECEIVE_BET_TIPS = 'CALENDAR/RECEIVE_BET_TIPS';
export const RECEIVE_BET_TIPS_ERROR = 'CALENDAR/RECEIVE_BET_TIPS_ERROR';

export const REQUEST_SPORT_ANALYSIS = 'CALENDAR/REQUEST_SPORT_ANALYSIS ';
export const RECEIVE_SPORT_ANALYSIS = 'CALENDAR/RECEIVE_SPORT_ANALYSIS ';
export const RECEIVE_SPORT_ANALYSIS_ERROR =
  'CALENDAR/RECEIVE_SPORT_ANALYSIS_ERROR ';
